import React from 'react'

const PresentationSection = (props) => {
  return (
    <div className="presentation-section" id={props.id}>{props.element}</div>
  )
}

export default PresentationSection